import clsx from "clsx";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import subscribeBackground from "common/images/subscribe-background.png";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    fullWidth: {
      marginLeft: "calc(50% - 50vw)",
      marginRight: "calc(50% - 50vw)",
    },
    subscribe: {
      backgroundPosition: "50% 50%",
      backgroundSize: "cover",
      overflow: "hidden",
      paddingBottom: "9rem !important",
      position: "relative",
      backgroundImage: `url(${subscribeBackground})`,
      textAlign: "center",
      color: "#ffffff",
      "@media (min-width: 48.0625em)": {
        paddingBottom: "3.5rem",
        paddingTop: "3.5rem",
      },
      "@media (min-width: 30.0625em) ": {
        paddingBottom: "2.625rem",
        paddingTop: "2.625rem",
      },
    },
    section: {
      paddingBottom: "1.875rem",
      paddingTop: "1.875rem",
      "@media (min-width: 30.0625em)": {
        paddingBottom: "2.625rem",
        paddingTop: "2.625rem",
      },
      "@media (min-width: 48.0625em)": {
        paddingBottom: "3.5rem",
        paddingTop: "3.5rem",
      },
    },
    subscribeTitle: {
      paddingBottom: "2.975rem",
      letterSpacing: ".175em",
      marginBottom: ".375rem",
      maxWidth: "39.1875rem",
      textTransform: "uppercase",
      marginLeft: "auto",
      marginRight: "auto",
    },
    subscribeText: {
      lineHeight: "1.5",
      marginBottom: "1.875rem",
      maxWidth: "39.1875rem",
      marginLeft: "auto",
      marginRight: "auto",
      "@media (min-width: 30.0625em)": {
        marginBottom: "2.625rem",
      },
      "@media (min-width: 48.0625em)": {
        marginBottom: "3.5rem",
      },
    },
    subscribeTextLink: {
      color: theme.palette.primary.main,
    },
    contactText: {
      backgroundColor: theme.palette.primary.main,
      border: "1px solid #fff",
      color: "#fff",
      margin: "auto",
      padding: "10px 60px",
      borderRadius: "0px",
      fontSize: "1.3rem",
      textTransform: "uppercase",
      textDecoration: "none",
      "&:hover": {
        backgroundColor: theme.palette.primary.dark,
      },
    },
  })
);

const ContactUsBanner = () => {
  const classes = useStyles();
  return (
    <Box
      className={clsx(classes.fullWidth, classes.subscribe, classes.section)}
    >
      <Container>
        <Typography
          component="h3"
          variant="h3"
          align="center"
          gutterBottom
          className={classes.subscribeTitle}
        >
          START READING TODAY
        </Typography>
        <Typography paragraph gutterBottom className={classes.subscribeText}>
          To find out how to subscribe click below or call{" "}
          <a className={classes.subscribeTextLink} href="tel:+1 646 891 2126">
            +1 646 891 2126
          </a>
        </Typography>
        <Button size="small" color="primary">
          <a className={classes.contactText} href="/subscribe-us">
            Subscribe Now
          </a>
        </Button>
      </Container>
    </Box>
  );
};

export default ContactUsBanner;
